import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-course-type",
  templateUrl: "./course-type.component.html",
  styleUrls: ["./course-type.component.css"]
})
export class CourseTypeComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
